import CloseIcon from "@mui/icons-material/Close";
import { Backdrop, Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { modalStyle } from "../../styles/commonStyles";

/**
 * Reusable Primary Modal Component
 * @param {boolean} open - Controls modal visibility
 * @param {function} handleClose - Function to close the modal
 * @param {string} title - Modal title
 * @param {React.Node} children - Modal body content
 */
const PrimaryModal = ({ open, handleClose, title, children }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }} aria-labelledby="primary-modal-title">
      <Fade in={open}>
        <Box sx={(theme) => modalStyle(theme)}>
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              top: theme.spacing(1),
              right: theme.spacing(1),
              color: "text.secondary",
            })}
            aria-label={t("modal.close")}
          >
            <CloseIcon />
          </IconButton>

          {/* Modal Title */}
          <Typography id="primary-modal-title" variant="h6" component="h2" sx={{ color: "primary.main", mb: 2 }}>
            {title}
          </Typography>

          {/* Modal Content */}
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default PrimaryModal;
